const LocationModal = ({ isOpen, onClose, title, details, mapUrl, mapButtonText, closeText }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-md transition-opacity"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="relative bg-white rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl p-8 flex flex-col gap-6 animate-fade-in shadow-blue/20 border border-blue1/10">
        <div className="flex justify-between items-center border-b border-gray-100 pb-4">
          <h2 className="text-2xl md:text-3xl font-serif italic font-medium text-black text-center w-full">
            {title}
          </h2>
        </div>

        <div className="flex flex-col gap-6 py-4">
          <div className="space-y-8 text-center">
            {details ? (
              <div className="text-base md:text-lg font-serif italic text-gray-800 leading-relaxed whitespace-pre-line px-2 md:px-12">
                {details.split(/\s*---\s*/).map((section, idx) => (
                  <div key={idx}>
                    {idx > 0 && (
                      <div className="w-full h-px bg-black mx-auto my-8 md:my-12 opacity-40 md:opacity-100" />
                    )}
                    <div className="whitespace-pre-line text-black">
                      {section.trim()}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-base md:text-lg font-serif italic text-gray-500 px-2 md:px-12">
                {title}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col items-center gap-3 pt-2">
          {mapUrl && (
            <a
              href={mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full md:w-auto px-10 py-3 bg-blue1 hover:bg-blue text-white rounded-xl font-serif italic transition-all duration-300 shadow-md text-center no-underline flex items-center justify-center gap-2"
            >
              📍 {mapButtonText || "Google Maps"}
            </a>
          )}
          <button
            onClick={onClose}
            className="w-full md:w-auto px-10 py-3 bg-gray-900 hover:bg-black text-white rounded-xl font-serif italic transition-all duration-300 shadow-md self-center"
          >
            {closeText || "✕"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationModal;
